export { default } from './work-at-yandex';
